import { EscapeCharsPipe } from './escape-chars.pipe';
import { SortListPipe } from '@app/shared/pipes/sort-list.pipe';
import { SearchListPipe } from '@app/shared/pipes/search-list.pipe';
import { SortByPipe } from '@app/shared/pipes/sort-by.pipe';
import { FilterLocationPipe } from './filter-location.pipe';
import { EscapeMedPipe } from '@app/shared/pipes/escape-med.pipe';
import { PhoneMaskPipe } from './mask-phone.pipe';
import { ReplaceCharsPipe } from '@app/shared/pipes/replace-chars.pipe';

export const pipes: any[] = [
  EscapeCharsPipe,
  SortListPipe,
  SearchListPipe,
  SortByPipe,
  FilterLocationPipe,
  EscapeMedPipe,
  PhoneMaskPipe,
  ReplaceCharsPipe,
];

export * from './escape-chars.pipe';
export * from './sort-list.pipe';
export * from './search-list.pipe';
export * from './sort-by.pipe';
export * from './filter-location.pipe';
export * from './escape-med.pipe';
export * from './mask-phone.pipe';
export * from './replace-chars.pipe';
